import { OddsType } from "app/utils/const";
import { intlShape } from "react-intl";
import { $Values } from "utility-types";
import store from "../store/store";
export class GetOddsTranslationsHelper {
  //
  static getOddsTranslations(intl: $Values<typeof intlShape>) {
    const oddsOptions = [
      {
        value: OddsType.DECIMAL,
        label: intl.formatMessage({
          id: "global-events-navigation-decimal",
        }),
      },
      {
        value: OddsType.US,
        label: intl.formatMessage({
          id: "oddstypes-US",
        }),
      },
      {
        value: OddsType.HONG_KONG,
        label: intl.formatMessage({
          id: "global-events-navigation-hong-kong",
        }),
      },
      {
        value: OddsType.INDONESIAN,
        label: intl.formatMessage({
          id: "global-events-navigation-indonesian",
        }),
      },
      {
        value: OddsType.MALAY,
        label: intl.formatMessage({
          id: "global-events-navigation-malay",
        }),
      },
    ];
    // Update the Competition List store with oddsOptions
    store.dispatch.competitionListModel.setOddsOptions({
      oddsOptions,
    });
  }
}
